module.exports = __webpack_public_path__ + "img/ai-icon-on.76f173ba.svg";